import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

// setup plugins for dayjs
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(isBetween);

type GenericDate = Date
    | string
    | number
    | dayjs.Dayjs;

export const isDateValid = (date: GenericDate): boolean => {
    return dayjs(date).isValid();
}

// get functions //
export const getEndOfDay = (date: GenericDate): dayjs.Dayjs => {
    return dayjs(date).endOf('day');
}

export const getStartOfDay = (date: GenericDate): dayjs.Dayjs => {
    return dayjs(date).startOf('day');
}

export const getDayjs = (date?: GenericDate, format?: string): dayjs.Dayjs => {
    return dayjs(date, format); // this is primarily to avoid including direct DayJS dependencies elsewhere
}

// formatting functions //
export const getFromNowDateString = (date: GenericDate): string => {
    return dayjs(date).fromNow();
}

export const formatDateLong = (date: GenericDate): string => {
    if (!date)
        return "";

    return dayjs(date).format("MM/DD/YYYY HH:mm A");
}

// comparison functions //
export const isDateAfter = (firstDate: GenericDate, secondDate: GenericDate): boolean => {
    return dayjs(firstDate).isAfter(dayjs(secondDate));
}

export const isDateBefore = (firstDate: GenericDate, secondDate: GenericDate): boolean => {
    return dayjs(firstDate).isBefore(dayjs(secondDate));
}

export const compareDates = (firstDate: GenericDate, secondDate: GenericDate): boolean => {
    if (!firstDate || !secondDate)
        return false;

    return dayjs(firstDate).isSame(dayjs(secondDate));
}

export const isSameDayOrBefore = (firstDate: GenericDate, secondDate: GenericDate): boolean => {

    return dayjs(firstDate).isSameOrBefore(dayjs(secondDate), 'day');
}

export const isSameDayOrAfter = (firstDate: GenericDate, secondDate: GenericDate): boolean => {

    return dayjs(firstDate).isSameOrAfter(dayjs(secondDate), 'day')
}

export const isBetweenDates = (selectedDate: GenericDate, firstDate: GenericDate, secondDate: GenericDate): boolean => {

    return dayjs(selectedDate).isBetween(firstDate, secondDate, null, '[]');
}

export const getDayjsDuration = (input: number, unit: plugin.DurationUnitType) => {
    return dayjs.duration(input, unit);
}
